
import { defineComponent } from "vue";

export default defineComponent({
  name: "Card2",
  props: {
    title: String,
    src_image: String,
    content: String,
    subTitle:String,
  },
  components: {},
});
